// extracted by mini-css-extract-plugin
export default {"copyNode":"CopyButton--copyNode--bb285a"};